module.exports = __webpack_public_path__ + "static/media/isophya_modestior_003_APA.cc32941c.mp3";